import { render, staticRenderFns } from "./remise.vue?vue&type=template&id=df4a04c8&"
import script from "./remise.vue?vue&type=script&lang=js&"
export * from "./remise.vue?vue&type=script&lang=js&"
import style0 from "./remise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports